import icon from 'vue-svgicon';

icon.register({
    'light/car-retro-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="19.5" cy="17" r="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M3.5 17h-3"/><circle pid="2" cx="5.5" cy="17" r="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M17.5 17h-10M1.5 17l.777-4.673A8.761 8.761 0 0 1 10.912 5a9.233 9.233 0 0 1 8.488 5.6L20 12c3 0 3.5 2.583 3.5 5h-2"/><path pid="4" d="M10.5 7c1.241 0 4.867-.469 7 4H5c.955-2 3.076-4 5.5-4zM10.5 7v4" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
});
